import React from 'react';
import { Button, DatePicker, Input, Space } from 'antd';
import { ClearOutlined, SearchOutlined } from '@ant-design/icons';

const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
};

const handleReset = (clearFilters) => {
    clearFilters();
};

export const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters
    }) => (
        <div style={{ padding: 8}}>
            <DatePicker
                placeholder='Fecha'
                style={{ marginRight: "10px" }}
                format="DD-MM-YYYY"
                onChange={e =>
                    setSelectedKeys(e !== null ? [e.format("YYYY-MM-DD")] : [])
                }
            />
            <br />
            <Button
                type="primary"
                onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                size="small"
                style={{ width: 95, marginRight: 8, marginTop: 5 }}
                icon={<SearchOutlined />}
            >
                Buscar
            </Button>
            <Button
                onClick={() => handleReset(clearFilters)}
                size="small"
                style={{ width: 30 }}
                icon={<ClearOutlined />}
            />
        </div>
    ),
    onFilter: (value, record) => 
        
        record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                //setTimeout(() => this.searchInput.select());
            }
        },
});

export const getColumnSearchPropsText = (title, dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
            <Input
                placeholder={`Buscar ${title}`}
                value={selectedKeys[0]}
                onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Space>
                <Button
                    type="primary"
                    onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{ width: 90 }}
                >
                    Buscar
                </Button>
                <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Restablecer
                </Button>
            </Space>
        </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: ((value, record) => {
        const props = dataIndex.split(".");
        
        if(props.length === 2) {
            return record[props[0]][props[1]].toString().toLowerCase().includes(value.toLowerCase());
        }

        if(props.length === 3) {
            return record[props[0]][props[1]][props[2]].toString().toLowerCase().includes(value.toLowerCase());
        }

        if(props.length === 4) {
            return record[props[0]][props[1]][props[2]][props[3]].toString().toLowerCase().includes(value.toLowerCase());
        }

        return record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
    }),
        
    onFilterDropdownVisibleChange: visible => {
        if (visible) {
            /*if(Object.keys(searchText).length > 0) {
                setTimeout(() => searchInput.select(), 100);
            }*/
        }
    },
});